<template>
    <div>
        <h3>Signup Sample</h3>
        <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="onSubmitSignup">
                <div>
                    <ValidationProvider name="아이디" rules="required|id" v-slot="{errors}" mode="eager">
                        <input v-model="signupInfo.id" type="text" placeholder="아이디">
                        <span>{{errors[0]}}</span>
                    </ValidationProvider>
                    <button type="button" v-on:click="onClickCheckId()">아이디 중복 검사</button>
                    {{checkIdState ? "사용 가능한 아이디 입니다." : "사용 불가능한 아이디 입니다."}}
                </div>
                <div>
                    <ValidationProvider name="비밀번호" rules="required|pw" v-slot="{errors}" vid="비밀번호" mode="eager">
                        <input v-model="signupInfo.password" type="text" placeholder="비밀번호">
                        <span>{{errors[0]}}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <ValidationProvider name="비밀번호 재확인" rules="required|confirmed:@비밀번호" v-slot="{errors}" vid="비밀번호 재설정" mode="eager">
                        <input v-model="confirmedPw" type="text" placeholder="비밀번호 재확인">
                        <span>{{errors[0]}}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <ValidationProvider name="이메일" rules="required|email" v-slot="{errors}" mode="eager">
                        <input v-model="signupInfo.email" type="text" placeholder="이메일">
                        <span>{{errors[0]}}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <ValidationProvider name="이름" rules="required|name" v-slot="{errors}" mode="eager">
                        <input v-model="signupInfo.name" type="text" placeholder="이름">
                        <span>{{errors[0]}}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <ValidationProvider name="휴대폰번호" rules="required|mobileTel" v-slot="{errors, valid}" mode="eager">
                        <input v-model="signupInfo.phoneNumber" type="text" placeholder="휴대폰번호">
                        <button type="button" @click="onClickSendVerifyNum(valid)">인증번호 받기</button>
                        <span>{{errors[0] == null ? message.phoneNumber : errors[0]}}</span>
                    </ValidationProvider>
                </div>
                <div>
                    <ValidationProvider name="인증번호" rules="required|verifyNum" v-slot="{errors, valid}" mode="eager">
                        <input v-model="verifyNum" type="text" placeholder="인증번호를 입력해주세요.">
                        <button  type="button" @click="onClickConfirmVerifyNum(valid)" :disabled="verifyNumCount == 0">인증번호 확인</button>
                        <span>{{errors[0] == null ? message.verifyNum : errors[0]}}</span>
                        <vac ref="verifyNumCounter" :autoStart="false" :end-time="new Date().getTime() + 62000">
                          <template v-slot:process="{ timeObj }">
                              {{onProcesssVerifyNumCounter(timeObj)}}
                          </template>
                          <template v-slot:finish>
                            {{onFinishVerifyNumCounter()}}
                          </template>
                        </vac>
                    </ValidationProvider>
                </div>
                <button type="submit" :disabled="invalid || !checkIdState">signup</button>
            </form>
        </ValidationObserver>
    </div>    
</template>
<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {mapActions} from 'vuex'
import axios from '@/axios/axios'

export default {
  name: 'SignupSample',
  components:{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      message: {
        phoneNumber: '',
        verifyNum: '',
      },
      signupInfo: {
        id: '',
        password: '',
        email: '',
        name: '',
        phoneNumber: '',
        roleName: this.$role.USER
      },
      confirmedPw: '',    // 비밀번호 재확인 값
      checkedId: '',      // 중복검사 완료된 아이디
      isVerified: false,  // 인증번호 검사 여부
      verifyNum: null,    // 인증번호 값
      verifyNumCount: 0,  // 인증번호 남은 유효 시간
    }
  },
  computed: {
    checkIdState(){
      return this.checkedId != '' && this.signupInfo.id == this.checkedId
    }
  },
  methods:{
    ...mapActions('auth', [
      'isAlreadyExistUsername', 
      'signup',
    ]),
    onSubmitSignup(){
      this.signup(this.signupInfo)
      .then((response) => {
        alert(response.data)
      })
      .catch((error) => {
        var data = error.response.data
        switch(data.ERROR){
          case "ALREADY_EXIST_ID":
            this.$alert("알림", "사용중인 아이디 입니다.")
            break
          case "ALREADY_EXIST_EMAIL":
            this.$alert("알림", "사용중인 이메일 입니다.")
            break
          case "ALREADY_EXIST_PHONE_NUMBER":
            this.$alert("알림", "사용중인 전화번호 입니다.")
            break
          default:
            this.$alert("알림", "요청 실패")
            break
        }
      })
    },
    onClickCheckId(){
      this.isAlreadyExistUsername(this.signupInfo.id)
      .then((response) => {
        var requestId = response.data.REQUEST_USERNAME
        var result = response.data.RESULT

        if(result == true){
          this.checkedId = ''
        }
        else {
          this.checkedId = requestId
        }
      })
      .catch(() => {
        this.checkedId = ''
      })
    },
    onClickSendVerifyNum(isValidPhoneNumber){
      if(!isValidPhoneNumber){
        return
      }

      return axios
      .post('/api/sms/send', {
        phoneNumber: this.signupInfo.phoneNumber,
        type: 'VERIFY',
        contents: '[경희대학교 뉴에이징플랫폼] 회원가입 전화번호 인증'
      })
      .then(response => {
        var data = response.data

        if(data.RESULT == 'true'){
          this.$refs.verifyNumCounter.startCountdown('restart')
          this.message.phoneNumber = 
          `인증번호를 발송했습니다.(유효시간 3분)
          인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.
          이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다.`
        }
        else{
          if(data.ERROR_CODE == 'SUCCESSIVE_REQUEST' || data.ERROR_CODE == 'BLOCKED'){
            this.message.phoneNumber = '5분 뒤에 다시 시도해주세요.'
          }
        }
      })
      .catch(error => {
        alert(error.response)
      })
    },
    onClickConfirmVerifyNum(isValidVerifyNum){
      if(!isValidVerifyNum){
        return
      }

      return axios
      .post('/api/sms/confirmVerifyNumber', {
        phoneNumber: this.signupInfo.phoneNumber,
        verifyNum: this.verifyNum
      })
      .then(response => {
        var data = response.data
        if(data.RESULT == "true"){
          this.isVerified = true
          this.$refs.verifyNumCounter.finishCountdown()
        }
        else{
          this.message.verifyNum = "유효하지 않은 인증번호 입니다."
        }
      })
      .catch(error => {
        alert(error.response)
      }) 
    },
    onProcesssVerifyNumCounter(timeObj){
      this.verifyNumCount = (timeObj.m ) * 60 + timeObj.s
      return `${timeObj.m}:${timeObj.s}`
    },
    onFinishVerifyNumCounter(){
      if(this.isVerified){
        this.message.verifyNum = '인증되었습니다.'
      }
      else{
        this.message.verifyNum = '인증번호의 유효 시간이 만료되었습니다.'
      }
    }
  }
}
</script>